/**
 * Base32 (RFC 4648) para semillas TOTP — UN solo alfabeto para todo el repo.
 * Auditoría de reutilización 28/09: `vault-totp.ts` (backend) y
 * `otpauth-migration.ts` (shared) tenían cada uno su copia del alfabeto.
 * Puro: corre en el navegador y en Lambda.
 */
export const BASE32_ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ234567';

/** Bytes → base32 canónico (mayúsculas, sin `=`), como lo pegan las apps de autenticación. */
export function base32Encode(bytes: Uint8Array): string {
  let bits = '';
  for (const b of bytes) bits += b.toString(2).padStart(8, '0');
  let out = '';
  for (let i = 0; i + 5 <= bits.length; i += 5) out += BASE32_ALPHABET[parseInt(bits.slice(i, i + 5), 2)];
  const rest = bits.length % 5;
  if (rest) out += BASE32_ALPHABET[parseInt(bits.slice(-rest).padEnd(5, '0'), 2)];
  return out;
}

/**
 * Lo que la gente pega → bytes: acepta espacios, guiones, minúsculas y `=`.
 * Lanza con mensaje para el usuario si está vacío o trae un carácter que no es base32.
 */
export function base32DecodeBytes(input: string): Uint8Array {
  const clean = input.toUpperCase().replace(/[\s\-=]/g, '');
  if (!clean) throw new Error('Semilla TOTP vacía');
  let bits = '';
  for (const ch of clean) {
    const idx = BASE32_ALPHABET.indexOf(ch);
    if (idx === -1) throw new Error(`Semilla TOTP inválida: carácter "${ch}" no es base32`);
    bits += idx.toString(2).padStart(5, '0');
  }
  const bytes: number[] = [];
  for (let i = 0; i + 8 <= bits.length; i += 8) bytes.push(parseInt(bits.slice(i, i + 8), 2));
  return Uint8Array.from(bytes);
}
